<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconFullscreenOff_16"
>
    <g clip-path="url(#IconFullscreenOff_16__a)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="m12.369 5.046 2.815.946a.515.515 0 0 1-.164 1.003h-5.5a.514.514 0 0 1-.515-.515V.98a.517.517 0 0 1 1.004-.163l.946 2.815L13.813.774a.999.999 0 1 1 1.414 1.414l-2.858 2.858ZM.98 9.005h5.5c.285 0 .515.23.514.514v5.5a.515.515 0 0 1-1.003.164l-.946-2.815-2.858 2.858a.999.999 0 1 1-1.414-1.414l2.858-2.858-2.815-.946A.514.514 0 0 1 .98 9.005Z"
            fill="currentColor"
        />
    </g>
    <defs>
        <clipPath id="IconFullscreenOff_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
    </defs>
</svg>
